module.exports = __webpack_public_path__ + "static/media/parts_4column_white.36f98f45.svg";